import { mediaBreakpointMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

import { getBodyContainerMarginLeftStyle, getLeftVerticalNavWidthStyle } from '../AppLayoutContainer/styles';

export const getLeftVerticalNavWidthZeroStyle = () => {
  return css`
    width: 0;
  `;
};

const centerMixin = `
 display: flex;
 justify-content: center;
 align-items: center;
`;

export const StyledHorizontalLayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  width: 100%;
  height: 100%;

  /* x <= 769 */
  @media ${mediaBreakpointMixin('md_lte')} {
    /* styles applied to small screen sizes and larger */
    border: 1px solid #f2d56b;

    /* display navigation as modal */
  }
`;

export const StyledVerticalNavigationContainer = styled.div<{ hideHeaderNavigation: boolean }>`
  position: fixed;

  height: 100%;
  ${({ hideHeaderNavigation = false }) => getLeftVerticalNavWidthStyle({ hideHeaderNavigation })}

  border-radius: 0px 0px 0px 16px;
  border-right: 1px solid ${token('colors.gray300')};
  background-color: white;
`;

export const StyledBodyContainer = styled.div<{ hideHeaderNavigation: boolean }>`
  ${centerMixin}
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;

  ${({ hideHeaderNavigation = false }) => getBodyContainerMarginLeftStyle({ hideHeaderNavigation })}
  overflow-y: auto;
`;

export const StyledBodyContentContainer = styled.div`
  width: 100%;
  height: 100%;
`;
